import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var IndexTree = /*#__PURE__*/function () {
  // 二维数组，_twoDimMap[i][j]表示第i个section中第j行的IIndexPath，在_oneDimMap中的index
  function IndexTree(_ref) {
    var {
      numberOfSections,
      numberOfRows
    } = _ref;

    _classCallCheck(this, IndexTree);

    _defineProperty(this, "_numberOfSections", void 0);

    _defineProperty(this, "_numberOfRows", void 0);

    _defineProperty(this, "_oneDimMap", void 0);

    _defineProperty(this, "_twoDimMap", void 0);

    this.update({
      numberOfSections,
      numberOfRows
    });
  }

  _createClass(IndexTree, [{
    key: "update",
    value: function update(_ref2) {
      var {
        numberOfSections,
        numberOfRows
      } = _ref2;
      this._numberOfSections = numberOfSections;
      this._numberOfRows = numberOfRows;

      this._generateDimMap();
    }
  }, {
    key: "numberOfRows",
    value: function numberOfRows(section) {
      return typeof this._numberOfRows === 'function' ? this._numberOfRows(section) : this._numberOfRows;
    }
  }, {
    key: "isFirst",
    value: function isFirst(_ref3) {
      var {
        section,
        row
      } = _ref3;
      return section === 0 && row === 0;
    }
  }, {
    key: "isLast",
    value: function isLast(_ref4) {
      var {
        section,
        row
      } = _ref4;
      return section === this._numberOfSections - 1 && this.isLastRowInSection({
        section,
        row
      });
    }
  }, {
    key: "indexOf",
    value: function indexOf(_ref5) {
      var {
        section,
        row
      } = _ref5;
      return this._twoDimMap[section][row];
    }
  }, {
    key: "isLastRowInSection",
    value: function isLastRowInSection(_ref6) {
      var {
        section,
        row
      } = _ref6;
      var numberOfRowInSection = this.numberOfRows(section);
      return numberOfRowInSection === row + 1;
    }
  }, {
    key: "_generateDimMap",
    value: function _generateDimMap() {
      this._twoDimMap = new Array(this._numberOfSections);
      this._oneDimMap = [];
      var oneDimIndex = 0;

      for (var i = 0; i < this._numberOfSections; i++) {
        // section 至少要有一个占位元素
        var rows = this.numberOfRows(i) || 1;
        this._twoDimMap[i] = new Array(rows);

        for (var j = 0; j < rows; j++) {
          this._twoDimMap[i][j] = oneDimIndex;
          this._oneDimMap[oneDimIndex] = {
            section: i,
            row: j
          };
          oneDimIndex += 1;
        }
      }
    }
  }, {
    key: "forEach",
    value: function forEach(indexPathStart, indexPathEnd, cb) {
      var {
        section: sectionStart,
        row: rowStart
      } = indexPathStart;
      var {
        section: sectionEnd,
        row: rowEnd
      } = indexPathEnd;
      var start = this._twoDimMap[sectionStart][rowStart];
      var end = this._twoDimMap[sectionEnd][rowEnd];

      for (var i = start; i <= end; i++) {
        cb(this._oneDimMap[i]);
      }
    }
  }, {
    key: "min",
    value: function min(one, other) {
      return this.compare(one, other) <= 0 ? one : other;
    }
  }, {
    key: "max",
    value: function max(one, other) {
      return this.compare(one, other) >= 0 ? one : other;
    }
  }, {
    key: "subCount",
    value: function subCount(indexPath, count) {
      var {
        section,
        row
      } = indexPath;
      var oneDimIndex = Math.max(0, this._twoDimMap[section][row] - count);
      return this._oneDimMap[oneDimIndex];
    }
  }, {
    key: "addCount",
    value: function addCount(indexPath, count) {
      var {
        section,
        row
      } = indexPath;
      var oneDimIndex = Math.min(this._oneDimMap.length - 1, this._twoDimMap[section][row] + count);
      return this._oneDimMap[oneDimIndex];
    }
  }, {
    key: "sub",
    value: function sub(one, other) {
      var {
        section,
        row
      } = one;
      var {
        section: sectionOther,
        row: rowOther
      } = other;
      return this._twoDimMap[section][row] - this._twoDimMap[sectionOther][rowOther];
    }
  }, {
    key: "compare",
    value: function compare(one, other) {
      if (!one) {
        return -1;
      }

      if (!other) {
        return 1;
      }

      if (one.section !== other.section) {
        return one.section - other.section;
      }

      if (one.row !== other.row) {
        return one.row - other.row;
      }

      return 0;
    }
  }]);

  return IndexTree;
}();

export { IndexTree as default };